// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Banner} from '../../../Banner';

export const BannerWithMargin = styled(Banner)`
  margin-top: 16px;
  margin-bottom: 16px;
  padding-right: 24px;
  font-style: normal;
  line-height: 140%;
`;
BannerWithMargin.displayName = 'S.BannerWithMargin';
